import {spriteSheetAssets} from "./spriteSheetAssets";
import {AnimatedSprite} from "pixi.js";
import {scatterSound} from "../soundService";

export class ReelSymbol {

    constructor({parentReel, iconName = 'icon1'}) {
        this.parentReel = parentReel;
        this.animatedSprite = new AnimatedSprite(spriteSheetAssets[iconName].animations['yBraking']);
        this.animatedSprite.animationSpeed = 0.85;
        this.animatedSprite.anchor.set(0.5);
        //////////
        // this.animatedSprite.scale.set(0.4);
        // this.animatedSprite.width = 130;
        // this.animatedSprite.height = 130;

        this.animatedSprite.loop = false;
        this.iconName = iconName;
    }

    setIcon(iconName) {
        // if(iconName==="scatter"){
        //     scatterSound.play();
        // }
        this.iconName = iconName;
        this.setYBreakingAnimation();
    }

    cleanSpriteOnCompleteFunction() {
        this.animatedSprite.onComplete = () => {
        }
    }

    playYBrakingAnimation() {
        return new Promise((resolve)=>{
            this.setYBreakingAnimation();
            this.animatedSprite.play();
            this.animatedSprite.onComplete = () => {
                this.cleanSpriteOnCompleteFunction();
                resolve();
            }
        })
    }

    playHighlightingAnimation() {
        return new Promise((resolve)=>{
            this.setHighlightingAnimation();
            this.animatedSprite.play();
            this.animatedSprite.onComplete = () => {
                this.cleanSpriteOnCompleteFunction();
                resolve();
            }
        })
    }

    setYBreakingAnimation() {
        this.animatedSprite.textures = spriteSheetAssets[this.iconName].animations['yBraking'];
    }

    setHighlightingAnimation() {
        this.animatedSprite.textures = spriteSheetAssets[this.iconName].animations['highlighting'];
    }

    setExplosionAnimation() {
        this.animatedSprite.textures = spriteSheetAssets.explosion.animations['explosion1'];
    }

    getSymbolIndexInParentReel() {
        return this.parentReel.symbols.indexOf(this);
    }

    explode() {
        return new Promise((resolve)=>{
            this.setHighlightingAnimation();
            this.animatedSprite.play();
            this.animatedSprite.onComplete = () => {
                this.setExplosionAnimation();
                this.animatedSprite.play();
                this.animatedSprite.onComplete = () => {
                    this.cleanSpriteOnCompleteFunction();
                    resolve();
                };
            }
        })
    }

    sendToUp() {
        this.animatedSprite.y = this.parentReel.symbols[0].animatedSprite.y - this.parentReel.symbolHeight;
        this.bringToBack();
    }

    bringToFront() {
        const index = this.getSymbolIndexInParentReel();
        this.parentReel.symbols.splice(index, 1);
        this.parentReel.symbols.push(this);
        this.parentReel.rearrangeChildrenBySymbolsArrangement();
    }

    bringToBack() {
        const index = this.getSymbolIndexInParentReel();
        this.parentReel.symbols.splice(index, 1);
        this.parentReel.symbols.unshift(this);
        this.parentReel.rearrangeChildrenBySymbolsArrangement();
    }

    bringToFrontVisual() {
        if (this.parentReel.container.children.indexOf(this.animatedSprite) !== -1) {
            this.parentReel.container.removeChild(this.animatedSprite);
            this.parentReel.container.addChild(this.animatedSprite);
        }
    }


}